var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Answer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_981",
    "data-name": "Rectangle 981",
    width: 24,
    height: 24,
    transform: "translate(-8015 7135)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Answer",
    "data-name": "Icon/Answer",
    transform: "translate(8015 -7135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897",
    transform: "translate(-8010.286 7137.143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_980",
    "data-name": "Rectangle 980",
    width: 13.714,
    height: 12,
    transform: "translate(0.637)",
    fill: "#fea627"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    "data-name": "Line 146",
    y2: 12,
    transform: "translate(4.065)",
    fill: "none",
    stroke: "#f7cc8e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_147",
    "data-name": "Line 147",
    y2: 12,
    transform: "translate(7.494)",
    fill: "none",
    stroke: "#f7cc8e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_148",
    "data-name": "Line 148",
    y2: 12,
    transform: "translate(10.922)",
    fill: "none",
    stroke: "#f7cc8e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M4.849,4.849,9.7,0l.9,10.6L0,9.7Z",
    transform: "translate(7.494 5.143) rotate(45)",
    fill: "#f7e8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M1.319,1.319,2.638,0l.245,2.883L0,2.638Z",
    transform: "translate(7.494 16.053) rotate(45)",
    fill: "#253435"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswer);
export default __webpack_public_path__ + "static/media/Answer.b15db3ca.svg";
export { ForwardRef as ReactComponent };